var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"document-title",rawName:"v-document-title",value:(_vm.title),expression:"title"}],attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }